var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedications = function SvgMedications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medications_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M1.5 4.5c0-1.103.897-2 2-2s2 .897 2 2V8h-4zM0 4.5v7C0 13.434 1.566 15 3.5 15S7 13.434 7 11.5V5.925c.056.597.256 1.188.619 1.713l4.015 5.853a3.457 3.457 0 0 0 4.875.878c1.585-1.131 1.97-3.36.86-4.975L13.353 3.54a3.455 3.455 0 0 0-4.875-.878A3.59 3.59 0 0 0 7 5.256V4.5C7 2.566 5.434 1 3.5 1A3.5 3.5 0 0 0 0 4.5m8.856 2.29c-.653-.95-.415-2.256.494-2.906.89-.637 2.125-.428 2.766.507l2.09 3.047-3.315 2.318z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medications_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v16H0z"
  })))));
};
export default SvgMedications;